import groupsEdit from '@/views/groups/edit'
import groupsList from '@/views/groups/list'

export default [
  {
    path: '/grupos',
    name: 'groupsList',
    component: groupsList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'groups',
      heading: 'menu.groups',
      auth: true,
      roles: [
        {
          create:  ['super-admin'],
          edit: ['super-admin'],
          remove: ['super-admin']
        }
      ]
    }
  },
  {
    path: '/grupos/novo',
    name: 'groupsCreate',
    component: groupsEdit,
    meta: {
      layout: 'sidebar',
      base: 'groups',
      heading: 'menu.groups',
      auth: true,
      roles: ['super-admin']
    }
  },
  {
    path: '/grupos/:id/editar',
    name: 'groupsUpdate',
    component: groupsEdit,
    meta: {
      layout: 'sidebar',
      base: 'groups',
      heading: 'menu.groups',
      auth: true,
      roles: ['super-admin']
    }
  }
]
